<template>
    <div :class="'person' + (isMobile?' mobile':'')">
        <mHead :classType="'light'" :showBack="true" v-if="isMobile"></mHead>
        <pcHead v-else></pcHead>
        <div class="main">
            <img :src="person.backUrl" alt="">
            <div class="info">
                <div class="name">{{person.name}}&nbsp;&nbsp;{{isMobile?'':person.position}}</div>
                <div class="position" v-if="isMobile">{{person.position}}</div>
                <div class="content" v-html="person.desc">

                </div>
            </div>
        </div>
        <mBottom v-if="isMobile" :classType="'light'"></mBottom>
        <pcBottom v-else></pcBottom>
    </div>
</template>

<script>
import pcHead from '@/components/base/pc/mHead.vue'
import pcBottom from '@/components/base/pc/mBottom.vue'
import mHead from '@/components/base/mobile/mHead.vue'
import mBottom from '@/components/base/mobile/mBottom.vue'
export default {
    components:{ pcHead, pcBottom, mHead, mBottom },
    data() {
        return {
            person: {}
        }
    },
    mounted(){
        this.getList();
    },
    methods: {
        getList(){
            this.$http.get(this.service.dev.api.recommendList+'?pageId=' + (this.isMobile?'9':'4') ).then(response =>{
                if(response.status == 200){
                    let list = response.body || []
                    let id = this.$route.params.id;
                    if(list.length > 0){
                        list.map(item => {
                            if(item.keyName == 'personList') {
                                let personList = JSON.parse(item.content || '[]')
                                personList.map(item => {
                                    if(id == item.name) {
                                        this.person = item;
                                    }
                                })
                            }
                        })
                    }
                } else {
                    this.$message.error(response.message?response.message:'error');
                }
          }).catch((res)=>{
              this.$message.error('error');
          })
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/style/base.scss";
    .person {
        background: #FAFAFA;
        &.mobile {
            .main {
                margin-top: poToRem(54);
                > img {
                    margin-bottom: poToRem(20);
                    display: block;
                }
                .info {
                    width: 100%;
                    box-sizing: border-box;
                    padding: 0 poToRem(20);
                    text-align: left;
                    max-width: unset;
                    .name {
                        font-size: poToRem(24);
                        line-height: poToRem(36);
                        margin-bottom: 0;
                    }
                    .position {
                        font-size: poToRem(16);
                        line-height: poToRem(24);
                        margin-bottom: poToRem(20);
                    }
                    .content {
                        margin-bottom: poToRem(40);
                    }
                }
            }
        }
        .main {
            margin-top: 40px;
            >img {
                width: 100%;
                margin-bottom: 80px;
                display: block;
            }
            .info {
                width: 75%;
                max-width: 1200px;
                margin: 0 auto;
                .name {
                    font-size: 36px;
                    text-align: left;
                    margin-bottom: 32px;
                }
                .content {
                    text-align: left;
                    margin-bottom: 80px;
                }
            }
        }
    }
</style>

<style lang="scss">
@import "@/assets/style/base.scss";
    .person {
        .main {
            .info {
                .content {
                    p {
                        font-size: 16px;
                        color: rgba(0,0,0,0.6);
                        line-height: 32px;
                    }
                }
            }
        }
        &.mobile {
            .main {
                .content {
                    p {
                        font-size: poToRem(16);
                        line-height: poToRem(32);
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/modules/view/about/person.vue